import ROOT_PATHS, { WAGES_AND_INCOME_PATHS } from 'constants/paths';

export const PATHS = WAGES_AND_INCOME_PATHS;
export const ROOT_PATH_WAGES_AND_INCOME = ROOT_PATHS.WAGES_AND_INCOME;

export const BUTTON_GROUP_SX = {
  flexWrap: 'wrap',
  width: '100%',
  '& > button': {
    width: { xs: 'calc(100% - 4px)', sm: 'calc(50% - 4px)' },
  },
};

export const PAY_FREQUENCY = {
  annually: 'annually',
  semimonthly: 'semimonthly',
  weekly: 'weekly',
  monthly: 'monthly',
  biweekly: 'biweekly',
  hourly: 'hourly',
};

export const INCOME_CHECKLIST_PAY_TYPES = {
  anticipatedIncrease: 'anticipatedPayIncrease',
  basePay: 'basePay',
  bonuses: 'bonuses',
  childSupport: 'childSupport',
  income: 'income',
  military: 'military',
  selfEmployed: 'selfEmployed',
  overtime: 'overtime',
  tips: 'tips',
};

export const COMMON_PAY_FREQUENCY_OPTIONS = {
  WEEKLY: {
    value: PAY_FREQUENCY.weekly,
    text: 'afforda.wagesAndIncome.details.job.weekly',
  },
  MONTHLY: {
    value: PAY_FREQUENCY.monthly,
    text: 'afforda.wagesAndIncome.details.job.monthly',
  },
  ANNUALLY: {
    value: PAY_FREQUENCY.annually,
    text: 'afforda.wagesAndIncome.details.job.annually',
  },
};

export const WAGES_AND_INCOME_SECTION_NAMES = {
  CHOICES: 'choices',
  JOBS: 'jobs',
  ANTICIPATED_JOBS: 'anticipatedJobs',
  LAST_JOBS: 'lastJobs',
  NO_INCOME: 'noIncome',
  CHILD_SUPPORTS: 'childSupports',
  ALIMONIES: 'alimonies',
  SOCIAL_SECS: 'socialSecs',
  OTHER_INCOMES: 'otherIncomes',
  PUBLIC_AIDS: 'publicAids',
  GIFTS: 'gifts',
  UNEMPLOYMENTS: 'unemployments',
  PENSIONS: 'pensions',
  ONLINES: 'onlines',
  RENTAL_ASSISTANCE: 'rentalAssistance',
  TRUSTS: 'trusts',
};
